import React, {Component} from "react";
import PropTypes from 'prop-types';
import * as K from '../constants/constants';
import TabGroup from "./TabGroup";

import "./GlobalSearchField.css"

class GlobalSearchField extends Component {
	constructor(props) {
		super(props);

		// this.onToggle = this.onToggle.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);

		this.state = {
			isFocus : false
		}
	}
	componentDidMount() {
		// The toggle button is in the main navigation and outside the React DOM.
		let toggleButton = document.querySelector(K.SEL_SEARCH_TOGGLE);
		toggleButton.addEventListener("click", this.props.onSearchToggle);
		// this.refs.searchbutton.addEventListener("click")
	}
	onChangeHandler(e) {
		// e.target is the input field
		e.preventDefault();
		this.props.onSearchChange(e.target.value);
	}
	onSubmitClick(e) {
		e.preventDefault();
		this.props.onSearchSubmit( e.target.querySelector("input").value );
	}
	render() {
		// TODO: handle the text value in the text field when it's in focus and blurred
		// let textValue = this.state.isFocus ? ""
		let TabGroupRender = null;
		let searchTitleText = "Vad letar du efter?";
		let searchWordHtml = null;

		if(this.props.textValue.length > 0){
			TabGroupRender =
				<TabGroup
					tabs={this.props.tabs}
					onTabChange={this.props.onSearchFilter}
				/>

			searchTitleText = this.props.numberOfSearchResult + " Resultat för ";
			searchWordHtml = <span className="globalsearchfield-word">{this.props.textValue}</span>;

		}

		return (
			<div>
				<div className="globalsearchfield" data-js="globalsearchfield" data-stateopen={this.props.isOpen}>
					<form className="globalsearchfield-form" onChange={this.onChangeHandler} onSubmit={this.onSubmitClick}>
						<h3 className="globalsearchfield-title">{searchTitleText}{searchWordHtml}</h3>
						<label className="globalsearchfield-label" htmlFor="globalsearchfield-input">
							<input id="globalsearchfield-input" className="globalsearchfield-input" maxLength="50" name="text" type="text" placeholder={this.props.placeholder} />
							<button ref="searchbutton" className="globalsearchfield-button" type="submit" name="globalsearchfield-button"><span className="globalsearchfield-buttontext">Sök</span></button>
						</label>
					</form>
					{TabGroupRender}
				</div>
			</div>
		);
	}
}

GlobalSearchField.propTypes = {
	onSearchSubmit: PropTypes.func,
	onSearchChange: PropTypes.func,
	placeholder: PropTypes.string,
}
GlobalSearchField.defaultProps = {
	onSearchSubmit: () => {},
	onSearchChange: () => {},
	placeholder: K.SEARCH_PLACEHOLDER,
}

export default GlobalSearchField;



// WEBPACK FOOTER //
// ./src/js/components/GlobalSearchField.js